
import Head from 'next/head'
import { Layout } from 'slices/Layout'
import { getLayoutProps } from 'slices/Layout/global/layout'

import { pxToRem } from '@/shared/styles/themes'
import { Container } from '@mui/material'
import { styled } from '@mui/material/styles'

import { ContactSlice } from '../../slices/Help/ContactUsSlice'

import type { NextPage } from 'next'

const ContactPage: NextPage = () => {
  const layoutProps = getLayoutProps()

  return (
    <Layout {...layoutProps}>
      <Head>
        <title>Contact Us</title>
        <meta name="description" content="Contact Us Page" />
      </Head>

      <StyledPageContainer maxWidth="md">
        <ContactSlice />
      </StyledPageContainer>
    </Layout>
  )
}

const StyledPageContainer = styled(Container)`
  padding-top: ${pxToRem(40)}
  padding-bottom: ${pxToRem(40)}
  
  ${(props) => props.theme.breakpoints.down('sm')} {
    padding-top: ${pxToRem(24)}
    padding-bottom: ${pxToRem(24)}
  }
`

export default ContactPage

